import {motion, AnimatePresence} from 'framer-motion';
import { useContext, useEffect } from "react";
import GeneralContext from "../context/GeneralContext";
import { useNavigate } from "react-router-dom";
import logoMini from '../components/assets/logoMini.png';
import NavIcon from '../components/shared/NavIcon';
import { FaUser, FaUsers } from "react-icons/fa";
import { GiFiles, GiPalmTree, GiCutDiamond } from "react-icons/gi";
import { SlLogout } from "react-icons/sl";
import AdminWelcome from '../components/adminConsole/AdminWelcome';
import AdminPasswordReset from '../components/adminConsole/AdminPasswordReset';
import ManageUsers from '../components/adminConsole/ManageUsers';
import ManageRequests from '../components/adminConsole/ManageRequests';
import PendingRequests from '../components/adminConsole/requests/PendingRequests';
import RequestHistoryUsers from '../components/adminConsole/requests/RequestHistoryUsers';
import RequestHistoryRecent from '../components/adminConsole/requests/RequestHistoryRecent';
import ManageBenefits from '../components/adminConsole/ManageBenefits';
import ManagePoints from '../components/adminConsole/ManagePoints';
import AddUser from '../components/adminConsole/users/AddUser';
import ActiveUsers from '../components/adminConsole/users/ActiveUsers';
import RestoreUser from '../components/adminConsole/users/RestoreUser';
import RestoreUserPassword from '../components/adminConsole/users/RestoreUserPassword';
import RestoreUserQuestion from '../components/adminConsole/users/RestoreUserQuestion';
import InactiveUsers from '../components/adminConsole/users/InactiveUsers';
import AddBenefit from '../components/adminConsole/benefits/AddBenefit';
import BenefitList from '../components/adminConsole/benefits/BenefitList';
import EditBenefit from '../components/adminConsole/benefits/EditBenefit';
import UserHistory from '../components/adminConsole/requests/UserHistory';
import AdjustPoints from '../components/adminConsole/points/AdjustPoints';
import ResetPoints from '../components/adminConsole/points/ResetPoints';
import UsersPoints from '../components/adminConsole/points/UsersPoints';
import AdminHistoryPoints from '../components/adminConsole/points/AdminHistoryPoints';
import { IoIosMenu } from "react-icons/io";

function AdminConsole() {

    const { redirect, currentMenu, changeCurrentMenu, changeModalClass, setUserType, logout } = useContext(GeneralContext);

    const navigate = useNavigate();

    //const [currentMenu, setCurrentMenu] = useState('user');

    useEffect(() => {
      changeModalClass('adminButton');
      const redirectFunction = async () => {
          const redirectResponse = await redirect('admin');
          if (!redirectResponse.success) {navigate('/')} else {setUserType('admin')}
      }
      redirectFunction();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*
    const [ isMobile, setIsMobile ] = useState();

    useEffect(() => {
      window.innerWidth < 800 ? setIsMobile(true) : setIsMobile(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    */

    const logoutFunction = () => {
      logout();
      navigate('/');
    }

    const mobileModalFunction = () => {
      const mobileModal = document.getElementById("mobileModal");
      mobileModal.style.display = "block";
    }

    return (
      <>
      <div className='doubleColumnMain'>
      <motion.div
        key='leftColumnUser'
        className='menuDivAdmin'
        initial={{x: -500}}
        animate={{x: 0}}
        exit={{x: -500}}
        transition={{duration: 1}}>
          <div style={{textAlign: 'center'}}>
            <div className='desktopMenu'>
              <img src={logoMini} alt='logo' className='logoMenu' />
              <br />
              <br />
              <NavIcon text='Mi Usuario' buttonFunction={changeCurrentMenu} buttonArguments='user'>
                <FaUser size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Gestionar Usuarios' buttonFunction={changeCurrentMenu} buttonArguments='manage-users'>
                <FaUsers size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Solicitudes' buttonFunction={changeCurrentMenu} buttonArguments='manage-requests'>
                <GiFiles size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Beneficios' buttonFunction={changeCurrentMenu} buttonArguments='manage-benefits'>
                <GiPalmTree size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Cambio de Puntos' buttonFunction={changeCurrentMenu} buttonArguments={'manage-points'}>
                <GiCutDiamond size='40' color='#FFFFFF'/>
              </NavIcon>
              <br />
              <NavIcon text='Cerrar Sesión' buttonFunction={logoutFunction}>
                <SlLogout size='40' color='#FFFFFF'/>
              </NavIcon>
            </div>
          </div>
          <div className='mobileMenu'>
            <div className='mobileLeftColumn'>
              <img src={logoMini} alt='logo' className='logoMenu' />
            </div>
            <div className='mobileRightColumn'>
              <NavIcon text='' buttonFunction={mobileModalFunction}>
                <IoIosMenu size='40' color='#FFFFFF'/>
              </NavIcon>
            </div>
          </div>
      </motion.div>
      <motion.div
        key='rightColumnUser'
        className='mainContainer'
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        transition={{duration: 1, delay: 1}}>
          <AnimatePresence mode='wait'>
            {currentMenu === 'user' ? <AdminWelcome key='adminUserMenu'/> : null}
              {currentMenu === 'reset' ? <AdminPasswordReset key='adminResetMenu'/> : null}
            {currentMenu === 'manage-users' ? <ManageUsers key='adminUsersMenu'/> : null}
              {currentMenu === 'add-user' ? <AddUser key='addUserMenu'/> : null}
              {currentMenu === 'active-users' ? <ActiveUsers key='activeUsersMenu'/> : null}
                {currentMenu === 'restore-user' ? <RestoreUser key='restoreUserMenu'/> : null}
                  {currentMenu === 'reset-user-password' ? <RestoreUserPassword key='restoreUserPasswordMenu'/> : null}
                  {currentMenu === 'reset-user-question' ? <RestoreUserQuestion key='restoreUserQuestionMenu'/> : null}
              {currentMenu === 'inactive-users' ? <InactiveUsers key='inactiveUsersMenu'/> : null}
            {currentMenu === 'manage-requests' ? <ManageRequests key='adminRequestsMenu'/> : null}
              {currentMenu === 'pending-requests' ? <PendingRequests key='pendingRequestsMenu'/> : null}
              {currentMenu === 'requests-history-users' ? <RequestHistoryUsers key='pendingRequestsMenu'/> : null}
                {currentMenu === 'user-history-requests' ? <UserHistory key='userHistoryRequestsMenu'/> : null}
              {currentMenu === 'requests-history-recent' ? <RequestHistoryRecent key='pendingRequestsMenu'/> : null}
            {currentMenu === 'manage-benefits' ? <ManageBenefits key='adminBenefitsMenu'/> : null}
              {currentMenu === 'add-benefit' ? <AddBenefit key='adminAddBenefitsMenu'/> : null}
              {currentMenu === 'benefit-list' ? <BenefitList key='adminBenefitListMenu'/> : null}
                {currentMenu === 'edit-benefit' ? <EditBenefit key='adminBenefitEditMenu'/> : null}
            {currentMenu === 'manage-points' ? <ManagePoints key='adminPointsMenu'/> : null}
              {currentMenu === 'adjust-points' ? <AdjustPoints key='adminAdjustPointsMenu'/> : null}
              {currentMenu === 'reset-points' ? <ResetPoints key='adminResetPointsMenu'/> : null}
              {currentMenu === 'users-points' ? <UsersPoints key='adminUsersPointsMenu'/> : null}
              {currentMenu === 'admin-history-points' ? <AdminHistoryPoints key='adminHistoryPointsMenu'/> : null}
          </AnimatePresence>
      </motion.div>
    </div>
    </>
  )
}

export default AdminConsole